/**
 * Where a person lands after signing in (v7 Part E, "Landing screen by role"): the owner and the director on Home › My
 * day (the Director dashboard from CORE-11), the delivery supervisor on Live delivery, the plant manager on the Plant
 * overview, the farm office on the Farm overview, HR on People, everyone else on Home › My day. A role's landing is used
 * only if the person may open it; otherwise the next rule applies, and a landing that does not exist yet falls back to My
 * day. Presentation only — permissions decide what each screen shows.
 */
import { Navigate } from 'react-router-dom';
import { LANDING_BY_ROLE, LANDING_DEFAULT, screenById } from '@rtcom/domain';
import { useSession } from '../lib/session';

export function landingFor(roles: readonly string[], can: (permission: string) => boolean): string {
  const open = (id: string) => { const s = screenById(id); return s && can(s.permission) ? s.path : undefined; };
  for (const rule of LANDING_BY_ROLE) {
    if (rule.roles.some((r) => roles.includes(r))) { const path = open(rule.screen); if (path) return path; }
  }
  return open(LANDING_DEFAULT) ?? '/attention';
}

export function LandingRedirect() {
  const { access, can, isLoading } = useSession();
  if (isLoading) return null;
  const roles = (access?.grants ?? []).map((g) => g.role);
  return <Navigate to={landingFor(roles, can)} replace />;
}
